import { TokenCredentials } from '@azure/ms-rest-js';
import storage from 'local-storage-fallback';

import { KamigamePreRegistrationApi } from '@/api-client/generated/kamigamePreRegistrationApi';

const anonymousToken = 'anonymous';

// eslint-disable-next-line import/prefer-default-export
export function createApiClientWithToken(): KamigamePreRegistrationApi {
  const token = storage.getItem('sessionId');
  return new KamigamePreRegistrationApi(new TokenCredentials(token || anonymousToken), {
    baseUri: `${API_URL_BASE}/`,
    noRetryPolicy: true,
  });
}
